import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=87b0fbc8&scoped=true&"
import script from "./UploadTemplate.vue?vue&type=script&lang=js&"
export * from "./UploadTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b0fbc8",
  null
  
)

export default component.exports